// extracted by mini-css-extract-plugin
export default {"button_discount":"ButtonDiscount_button_discount__LDiRK","dark":"ButtonDiscount_dark__lXsnx"};